import type { IconData } from '@stacksjs/iconify-core'

export const ball: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3 24c0 11.598 9.402 21 21 21s21-9.402 21-21S35.598 3 24 3S3 12.402 3 24\"/><path d=\"M44.975 25.024c-10.782.518-19.433 9.169-19.95 19.951M38.75 9.25l-29.5 29.5m0-29.5l29.5 29.5M22.974 3.024c-.52 10.782-9.168 19.43-19.95 19.95\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default ball
